(function MoxMobileMenu() {
  const BIND_FLAG = 'moxAccordionBound';

  whenMenuReady(bindOnce);

  function whenMenuReady(cb) {
    const tryNow = () => {
      const container = document.querySelector('#menu_mobile');
      const root = document.querySelector('.mox-mmmb');
      if (container && root) return cb(container, root);
      return false;
    };
    if (tryNow()) return;

    const obs = new MutationObserver(() => {
      if (tryNow()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  function bindOnce(container /*, root */) {
    if (container.dataset[BIND_FLAG] === '1') return;
    container.dataset[BIND_FLAG] = '1';

    // 1) Click en cualquier summary → animar abrir/cerrar solo con JS
    container.addEventListener('click', (ev) => {
      const summary = ev.target.closest('summary');
      if (!summary || !container.contains(summary)) return;

      // ✅ Si el click fue en el LINK (texto/título), dejamos navegar.
      const link = ev.target.closest('a');
      if (link && summary.contains(link)) {
        // Importante: NO preventDefault
        return;
      }

      // ✅ Si el click fue en el toggle (icono), hacemos accordion
      const toggle = ev.target.closest('.mox-mmmb__toggle');
      if (toggle && summary.contains(toggle)) {
        ev.preventDefault();

        const details = summary.closest('details');
        if (!details) return;

        const isOpen = details.hasAttribute('open');
        if (isOpen) {
          animateAccordion(details, false);
        } else {
          closeSiblings(details);
          animateAccordion(details, true);
        }
        return;
      }

      // ✅ Si no fue link ni toggle:
      // - si quieres que al tocar "la fila" (pero no el texto) haga toggle, mantenemos tu comportamiento:
      ev.preventDefault();

      const details = summary.closest('details');
      if (!details) return;

      const isOpen = details.hasAttribute('open');
      if (isOpen) {
        animateAccordion(details, false);
      } else {
        closeSiblings(details);
        animateAccordion(details, true);
      }
    });


    // 2) Estado inicial de aria-expanded (SSR)
    syncAllAriaExpanded(container);
  }

  // Animar abrir/cerrar un <details> concreto
  function animateAccordion(detailsEl, shouldOpen) {
    const panel = detailsEl.querySelector(':scope > summary + .mox-mmmb__panel');
    if (!panel) return;

    const DURATION = 260;

    // cancelar animación anterior si la hubiera
    if (panel._moxAnim) {
      panel._moxAnim.cancel();
      panel._moxAnim = null;
    }

    panel.style.overflow = 'hidden';

    if (shouldOpen) {
      // --- ABRIR ---
      // marcamos como abierto para que el contenido tenga su altura real
      if (!detailsEl.hasAttribute('open')) {
        detailsEl.setAttribute('open', 'open');
      }

      const endHeight = panel.scrollHeight;
      const startHeight = 0;

      // estado inicial
      panel.style.maxHeight = startHeight + 'px';
      panel.style.opacity = 0;
      panel.style.paddingTop = '0px';
      panel.style.paddingBottom = '0px';

      const anim = panel.animate(
        [
          {
            maxHeight: startHeight + 'px',
            opacity: 0,
            paddingTop: '0px',
            paddingBottom: '0px',
          },
          {
            maxHeight: endHeight + 'px',
            opacity: 1,
            paddingTop: '8px',
            paddingBottom: '16px',
          },
        ],
        {
          duration: DURATION,
          easing: 'ease-out',
        }
      );

      panel._moxAnim = anim;

      anim.onfinish = () => {
        panel._moxAnim = null;

        // dejamos el panel "limpio"; el alto pasa a ser auto
        panel.style.maxHeight = '';
        panel.style.opacity = '';
        panel.style.paddingTop = '';
        panel.style.paddingBottom = '';

        detailsEl.setAttribute('open', 'open');
        const summary = detailsEl.querySelector(':scope > summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      };

      anim.oncancel = () => {
        panel._moxAnim = null;
      };
    } else {
      // --- CERRAR ---
      // mantenemos open=true durante la animación para que el contenido no desaparezca
      if (!detailsEl.hasAttribute('open')) {
        detailsEl.setAttribute('open', 'open');
      }

      const startHeight = panel.scrollHeight;
      const endHeight = 0;

      panel.style.maxHeight = startHeight + 'px';
      panel.style.opacity = 1;
      panel.style.paddingTop = '8px';
      panel.style.paddingBottom = '16px';

      const anim = panel.animate(
        [
          {
            maxHeight: startHeight + 'px',
            opacity: 1,
            paddingTop: '8px',
            paddingBottom: '16px',
          },
          {
            maxHeight: endHeight + 'px',
            opacity: 0,
            paddingTop: '0px',
            paddingBottom: '0px',
          },
        ],
        {
          duration: DURATION,
          easing: 'ease-in',
        }
      );

      panel._moxAnim = anim;

      anim.onfinish = () => {
        panel._moxAnim = null;

        detailsEl.removeAttribute('open');

        panel.style.maxHeight = '';
        panel.style.opacity = '';
        panel.style.paddingTop = '';
        panel.style.paddingBottom = '';

        const summary = detailsEl.querySelector(':scope > summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      };

      anim.oncancel = () => {
        panel._moxAnim = null;
      };
    }
  }

  function closeSiblings(detailsEl) {
    const parent = detailsEl.parentElement;
    if (!parent) return;

    const openSiblings = parent.matches('ul,ol')
      ? parent.querySelectorAll(':scope > li > details[open]')
      : parent.querySelectorAll(':scope > details[open]');

    openSiblings.forEach((d) => {
      if (d !== detailsEl) {
        animateAccordion(d, false);
      }
    });
  }

  function syncAllAriaExpanded(scope) {
    scope.querySelectorAll('details > summary').forEach((summary) => {
      const d = summary.parentNode;
      if (!(d instanceof HTMLDetailsElement)) return;
      summary.setAttribute('aria-expanded', d.hasAttribute('open') ? 'true' : 'false');
      summary.style.userSelect = 'none';
    });
  }
})();
